import { render } from "./customerreview.vue?vue&type=template&id=ca6cc88e"
import script from "./customerreview.vue?vue&type=script&lang=js"
export * from "./customerreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__